import { extractUtmFromUrl } from './utm-tags';

const getUrlWithQueries = (url: string) => {
  const isUrlWithParam = url.includes('?');
  const utmParams = extractUtmFromUrl();

  if (!utmParams || !Object.keys(utmParams).length) {
    return url;
  }

  const paramsPrefix = isUrlWithParam ? '&' : '?';
  return `${url}${paramsPrefix}${new URLSearchParams(utmParams).toString()}`;
};

/**
 * Method to open different mini apps.
 * Keeps UTM params if they are present in the url.
 */
const openMiniApp = (...paths: string[]) => {
  const url = paths.join('/');
  const isUrlWithUtmParams = url.includes('?utm') || url.includes('&utm');

  // If the given `paths` already have some UTM params,
  // we don't need to extract them from `window.location`
  if (isUrlWithUtmParams) {
    window.location.assign(url);
    return;
  }

  const urlWithQueries = getUrlWithQueries(url);

  window.location.assign(urlWithQueries);
};

/**
 * Method to open different mini apps.
 * All mini apps are deployed on the same domain, so we only need to open mini app's base path
 *
 * @example
 *
 * https://freedom-mini-apps-staging-frontend.dev.cloud.aviata.team/avia
 * https://freedom-mini-apps-staging-frontend.dev.cloud.aviata.team/cabinet/
 * https://freedom-mini-apps-staging-frontend.dev.cloud.aviata.team/passengers/
 */
export const appNavLinks = {
  openAvia: (...paths: string[]) => openMiniApp('/avia', ...paths),
  openCabinet: (...paths: string[]) => openMiniApp('/cabinet', ...paths),
  openPassengers: (...paths: string[]) => openMiniApp('/passengers', ...paths),
  openRailways: (...paths: string[]) => openMiniApp('/railways', ...paths),
  openTours: (...paths: string[]) => openMiniApp('/tours', ...paths),
};
